<template>
  <v-ons-page id="urgences" class="l-content l-document">
    <custom-toolbar backLabel="Retour">{{ $t("Conciergerie / Location") }}</custom-toolbar>

    <div class="container">
      <v-ons-button v-for="(region, key) in keyholding_regions" :key="key" modifier="large" @click="view(region);">
        <i class="fas fa-map-marker-alt"></i>
        {{ region.name }}
        <i class="fas fa-map-marker-alt absoluteIcon"></i>
      </v-ons-button>
    </div>
  </v-ons-page>
</template>

<script>
import KeyholdingRegion from './KeyholdingRegion.vue';

export default {
  data() {
    return {
      KeyholdingRegion: KeyholdingRegion,
      keyholding_regions: null,
    };
  },
  methods: {
    view(region) {
      self = this;
      this.$store.commit('navigator/push', {
        extends: KeyholdingRegion,
        data() {
          return {
            region: region
          };
        }
      });
    }
  },
  created() {
    this.keyholding_regions = [
      {
        name: "Costa Blanca",
        key: "common"
      },
      {
        name: "Costa del Sol",
        key: "costa_del_sol"
      },
      {
        name: "Costa Almeria",
        key: "common"
      },
      {
        name: "Costa Calida",
        key: "common"
      }
    ];
  }
};
</script>


// WEBPACK FOOTER //
// Keyholding.vue?7da5358e